import { Heading, SpecialSpan } from '@gassan-ui'
import { Article_article } from '@graphql/__generated__/Article'
import React, { FC } from 'react'

const Title: FC<Article_article> = props => {
  return (
    <h1 data-test-id="product-page-title">
      <Heading
        variant="h1"
        as="span"
        display="block"
        mb={['.25rem', '1rem']}
        color={props.isOutOfCollection ? 'shades.500' : 'shades.800'}
      >
        {props.brand}
      </Heading>
      <SpecialSpan color="shades.500" variant="two">
        {props.description}
      </SpecialSpan>
    </h1>
  )
}

export default Title
